import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PORTAL_CONFIG_FEATURE_KEY,
  PortalConfigState,
} from './portal-config.reducer';

// Lookup the 'PortalConfig' feature state managed by NgRx
export const selectPortalConfigState = createFeatureSelector<PortalConfigState>(
  PORTAL_CONFIG_FEATURE_KEY
);

export const selectPortalConfigLoaded = createSelector(
  selectPortalConfigState,
  (state: PortalConfigState) => state.loaded
);

export const selectPortalConfigError = createSelector(
  selectPortalConfigState,
  (state: PortalConfigState) => state.error
);

export const selectPortalConfigDefinition = createSelector(
  selectPortalConfigState,
  (state: PortalConfigState) => state.config
);

export const selectUserConfigIds = createSelector(
  selectPortalConfigState,
  (state: PortalConfigState) => state.userConfigIds
);

export const selectActivePortalId = createSelector(
  selectPortalConfigState,
  (state: PortalConfigState) => state.activePortalId
);

export const selectActivePortalConfig = createSelector(
  selectPortalConfigDefinition,
  selectActivePortalId,
  (definition, activeId) => (activeId ? definition[activeId] : undefined)
);

export const selectActivePortalConfigIdAndLoaded = createSelector(
  selectActivePortalId,
  selectPortalConfigLoaded,
  (activeId, loaded) => ({ activeId, loaded })
);
